import styled, { css } from 'styled-components';
export const ChipsWrapper = styled.div `
  display: flex;
  flex-wrap: ${({ nowrap }) => (nowrap ? 'nowrap' : 'wrap')};
  gap: 8px;
  flex-direction: ${({ inline }) => (inline ? 'row' : 'column')};
  align-items: ${({ isLoading }) => (isLoading ? 'center' : 'flex-start')};
  justify-content: ${({ isLoading }) => (isLoading ? 'center' : 'flex-start')};
  min-height: 32px;
  min-width: 32px;
  width: 100%;
  ${({ spacer }) => spacer &&
    css `
      margin-top: 12px;
      margin-bottom: 12px;
    `}
`;
export const ChipItem = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 20px;
  user-select: none;
  ${({ theme }) => theme.typography.textMedium};
  ${({ theme }) => theme.typography.weightMedium}
  outline: 1px solid;
  outline-offset: -1px;
  background-color: ${({ theme, checked, disabled }) => {
    if (disabled)
        return checked ? theme.colors.mainLight : theme.colors.grey10_2;
    return checked ? theme.colors.main : 'none';
}};
  color: ${({ theme, checked, disabled }) => {
    if (disabled)
        return theme.colors.grey70_3;
    return checked ? theme.colors.grey00_2 : theme.colors.grey100_1;
}};
  outline-color: ${({ theme, multi, checked, disabled }) => {
    if (!checked && !disabled)
        return multi ? theme.colors.mainLight : theme.colors.grey30_1;
    return 'transparent';
}};
  cursor: ${({ disabled, isClickable }) => {
    if (disabled)
        return 'not-allowed';
    if (isClickable)
        return 'pointer';
    return 'default';
}};

  &:hover {
    ${({ theme, multi, checked, disabled, isClickable }) => {
    if (!isClickable || disabled)
        return '';
    if (multi)
        return checked
            ? css `
              background-color: ${theme.colors.mainDark};
            `
            : css `
              outline-color: ${theme.colors.mainDark};
            `;
    return checked
        ? css `
            background-color: ${theme.colors.mainDark};
          `
        : css `
            outline-color: ${theme.colors.grey70_1};
          `;
}}
  }

  &:focus-visible {
    ${({ theme }) => theme.shadows.focus}
    outline: 0;
  }

  ${({ multi, checked }) => multi &&
    css `
      &:before {
        content: '';
        display: block;
        width: 2px;
        height: 2px;
        border-radius: 50%;
        border: 2px solid currentcolor;
        ${checked &&
        css `
          background-color: currentcolor;
        `}
      }
    `}
`;
